import React from 'react';
import PropTypes from 'prop-types';

const PlayTime = ({ minPlayTime, maxPlayTime, iconSize, iconColour, textColourClass, textSizeClass, marginClasses }) => {
  return (
    <p className={`flex items-center ${textSizeClass} ${textColourClass} ${marginClasses}`}>
      <svg className="mr-2" fill={iconColour} xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize} viewBox="0 0 24 24">
        <path d="M13 12l-.688-4h-.609l-.703 4c-.596.347-1 .984-1 1.723 0 1.104.896 2 2 2s2-.896 2-2c0-.739-.404-1.376-1-1.723zm-1-8c-5.522 0-10 4.477-10 10s4.478 10 10 10 10-4.477 10-10-4.478-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-2-19.819v-2.181h4v2.181c-1.438-.243-2.592-.238-4 0zm9.179 2.226l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.926-1.5-1.328z"/>
      </svg>
      { minPlayTime } { maxPlayTime ? ` - ${maxPlayTime} min.` : 'min.' }
    </p>
  );
};

PlayTime.propTypes = {
  minPlayTime: PropTypes.number.isRequired,
  maxPlayTime: PropTypes.number,
  iconSize: PropTypes.number,
  iconColour: PropTypes.string,
  textColourClass: PropTypes.string,
  textSizeClass: PropTypes.string,
  marginClasses: PropTypes.string,
};

PlayTime.defaultProps = {
  iconSize: 24,
  iconColour: '#000000',
  textSizeClass: 'text-sm',
};

export default PlayTime;
